import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from 'crypto-js';
import { selectUserDetails } from '../../../redux/features/auth/authSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
const secretKey = 'super-secret-key';

const ReferralMaterials = () => {

    const dispatch = useDispatch();

    const { details } =
        useSelector(selectUserDetails);

    const handleCopyLink = () => {
        const encryptedId = CryptoJS.AES.encrypt(`${details?.id}`, secretKey).toString();
        const safeEncrypted = encodeURIComponent(encryptedId);
        const link = `https://studyhub.lk/promo/${safeEncrypted}`;
        // const link = `http://localhost:3000/promo/${safeEncrypted}`;

        navigator.clipboard.writeText(link)
            .then(() => toast.success("Registration link copied!"))
            .catch(() => toast.error("Failed to copy link"));
    };

    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <h1 className={`form-title`}>Referral Materials</h1>
                <button
                    className={styles.createNewStudent}
                    onClick={handleCopyLink}
                >
                    Registration Link
                    <FontAwesomeIcon icon={faCopy} className={styles.fontIcon} />
                </button>
                <div className={styles.formContainer}>
                </div>
            </div>
        </div>
    );
};

export default ReferralMaterials;